// src/config/index.js

/**
 * 获取 URL 查询参数
 * @param {string} name - 参数名
 * @returns {string|null} - 参数值
 */
function getUrlParam(name) {
  // 创建 URLSearchParams 实例，自动解析当前页面的查询字符串
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

// 获取 username 参数
const username = getUrlParam('username');

// 导出其他可能存在的配置...
// export const otherConfig = ...;

// 导出 username
export { username };
